<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card class="data-ive">
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>用户使用白板排名</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持用户名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--用户白板列表-->
                <div class="table-wrapper-data">
                    <Table :columns="userBoardColumn" :data="userBoardList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {
        queryUserRankList
    } from "../../../service/api.js";

    export default {
        name: "cloud-board-userList",
        data () {
            return {
                schoolId: this.$route.query.schoolId,//学校id
                keyWord: "",//关键字
                page: 1,//当前页面
                limit: 10,//页面数据数量
                total: 0,//页面数据总数
                pageCount: 0,//页数
                userBoardList: [],//学校使用白板排名集合
                userBoardColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "realname",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "查看用户列表",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookUserDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.realname
                                )
                            ]);
                        }
                    },
                    {
                        title: "用户所在学校",
                        key: "school_name",
                        align: "center"
                    },
                    {
                        title: "手机号",
                        key: "mobile",
                        align: "center"
                    },
                    {
                        title: "用户名",
                        key: "user_name",
                        align: "center"
                    },
                    {
                        title: "用户使用白板数",
                        key: "whiteboardCount",
                        align: "center"
                    }
                ]
            }
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "cloudBoardStatic",
                    query: {
                        tabsName: "schoolUseBoardRank",
                    }
                });
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                //获取用户白板统计
                this.findUserRankList();
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                //获取用户白板统计
                this.findUserRankList();
            },
            /**
             * 获取用户白板统计
             */
            async findUserRankList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await queryUserRankList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.userBoardList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 点击查看用户使用白板详情
             */
            lookUserDetails (row) {
                let routeData = this.$router.resolve({
                    name: "userBoardDetails",
                    query: {
                        userId: row.userid
                    }
                });
                window.open(routeData.href, '_blank');
            }
        },
        mounted () {
            //获取用户白班统计
            this.findUserRankList();
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", '云白板');
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";

    .laypage_main {
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
</style>
<style lang="scss">
    .data-ive{
        .ivu-card {
            margin-top: 0 !important;
        }
    }
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
